







































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

import { Course } from 'frontend/types';
import BriocheBackgroundImage from 'frontend/components/BriocheBackgroundImage.vue';

@Component({
  components: { BriocheBackgroundImage },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class CoverDescriptions extends Vue {
  @Prop({ type: Object, required: true })
  private course!: Course;
  @Prop({ type: Number, required: true })
  private lessons!: number;
  @Prop({ type: Boolean, required: true })
  private hasPractice!: boolean;
  @Prop({ type: Boolean, default: false })
  private hideStats!: boolean;
}
